import { reactive } from "vue"

const state = reactive({
  buying: true,
  showLogin: false
})

export default {
  state
}